import { Injectable } from '@angular/core';
import { FolderManagementServiceModel } from '@app/origami-api/services/folder-management.service';
import { Topic, TopicUtils } from '@app/origami-api/utils/topic-utils';
import { Observable, of } from 'rxjs';
import { TopicTypeId, TopicTypeName } from '@app/origami-api/constants/topic-type-names';
import { FieldNames } from '@app/origami-api/constants/field-names';
import { Field } from '@app/origami-api/constants/field-flag';
import { SessionService } from '@app/session/session.service';
import { TopicSearchService } from '@app/origami-api/services/topic-search.service';
import { ConfigService, ConfigServiceModel } from '@app/origami-api/services/config.service';
//import * as moment from 'moment';
import { map, concatMap } from 'rxjs/operators';

@Injectable()
export class PotentialDuplicatesService {
  constructor(
    private sessionService: SessionService,
    private topicSearchService: TopicSearchService,
    private configService: ConfigService,
  ) {}

  getPotentialDuplicates(document: FolderManagementServiceModel.Document): Observable<Topic[]> {
    return this.getDocumentFormFields(document).pipe(
      //map(relatedFields => TopicUtils.getTopicFieldValue(document.TopicFields, FieldNames.Document.FormIds)),
      map((relatedFields) =>
        relatedFields
          .filter((field) => Field.Is.includeInContact(field) || this.isDefaultField(field))
          .sort((field1, field2) => field1.SortOrder - field2.SortOrder),
      ),
      map((relatedFields) => ({
        siteId: this.sessionService.currentRoomId,
        searchQuery: this.getSearchQuery(document),
        fieldListing: `${FieldNames.Document.DuplicateStatusId}`,
        topicTypeId: TopicTypeId.Document,
        module: 2, // Non SSU docs
      })),
      concatMap((searchParams) => this.topicSearchService.searchTopics(searchParams, true)),
      map((response) => response.Result.TopicList.filter((topic) => topic.TopicId !== document.TopicId)),
    );
  }

  getEssentialFieldNames(): FieldNames.Document[] {
    return [FieldNames.Document.DocumentId, FieldNames.Document.DocumentStatusId];
  }

  isDefaultField(field) {
    return field && this.getEssentialFieldNames().includes(field.FieldName);
  }

  getDocumentFormFields(document: FolderManagementServiceModel.Document): Observable<ConfigServiceModel.Field[]> {
    const formIds = TopicUtils.getTopicFieldValue(document.TopicFields, FieldNames.Document.FormIds);
    const formId = formIds ? +formIds.split(',')[0] : null;

    if (!formId) {
      return of([]);
    }

    return this.configService.getCustomFieldsForm({ formId }).pipe(
      map((res) => {
        if (!res || !res.Result || !res.Result.FormFields) {
          return [];
        }
        return res.Result.FormFields;
      }),
    );
  }

  getDefaultFormFields(fields, siteId) {
    if (fields && fields.length) {
      return of(fields);
    }
    return this.sessionService.forms.getForms([TopicTypeName.Document], siteId).pipe(
      map((res) => {
        if (!res || !res[TopicTypeName.Document] || !res[TopicTypeName.Document].Fields) {
          return [];
        }
        return res[TopicTypeName.Document].Fields;
      }),
    );
  }

  private getSearchQuery(document: FolderManagementServiceModel.Document): string {
    const hash = TopicUtils.getTopicFieldValue(document.TopicFields, FieldNames.Document.OriginalDocumentHash);
    if (hash) {
      return `[${FieldNames.Document.OriginalDocumentHash}] = \'${hash}\' AND TopicAttributes.TopicId != ${document.TopicId} order by [${FieldNames.Document.DocumentId}] ASC`;
    }

    return `TopicAttributes.TopicId == ${document.TopicId} order by [${FieldNames.Document.DocumentId}] ASC`;
  }
}
